import { gettext } from '@eventbrite/i18n';
import { sdkRequest, translateServerErrors } from '@eventbrite/http';
import { deepKeysToCamel } from '@eventbrite/transformation-utils';
import { formatUrl } from 'url-lib';

import { MAX_CONFLICT_WITHOUT_PAGINATION } from '../constants/downgrade';

const ORGANIZATIONS_API_URL = '/api/v3/organizations/';
const _getAssortmentApiUrl = (activeScopeUserId) =>
    `${ORGANIZATIONS_API_URL}${activeScopeUserId}/assortment/`;
const _getEventsWithConflictsUrl = ({
    desiredPackage,
    organizationId,
    pageNumber = '1',
}) =>
    formatUrl(
        `${ORGANIZATIONS_API_URL}${organizationId}/assortment_downgrade_conflicts/`,
        {
            plan: desiredPackage,
            page: pageNumber,
            page_size: MAX_CONFLICT_WITHOUT_PAGINATION,
        },
    );

const EVENTS_API_URL = '/api/v3/events/';

const _getEventsDataUrl = (ids) =>
    formatUrl(`${EVENTS_API_URL}`, {
        event_ids: ids.join(','),
        expand: 'logo',
        include_parent_events: 1,
    });

const NOT_AUTHORIZED_ERROR = gettext(
    'You do not have permission to access the resource you requested.',
);
const NOT_FOUND_ERROR = gettext('The profile you requested does not exist.');
const RATE_LIMIT_ERROR = gettext(
    'You have exceeded the allowed number of package changes.',
);
const INCOMPATIBLE_EVENT_ERROR = gettext(
    'We could not change the package for your current event, but any future events will have the new package.',
);
const STANDARD_SERVER_ERROR = gettext(
    'There was an issue with the server, try again',
);

const GET_SET_ERROR_SPEC = {
    NOT_AUTHORIZED: () => NOT_AUTHORIZED_ERROR,
    NOT_FOUND: () => NOT_FOUND_ERROR,
    HIT_RATE_LIMIT: () => RATE_LIMIT_ERROR,
    INCOMPATIBLE_EVENT: () => INCOMPATIBLE_EVENT_ERROR,
    default: () => STANDARD_SERVER_ERROR,
};

export const setAssortment = ({ activeScopeUserId, plan, version, eventId }) =>
    sdkRequest(_getAssortmentApiUrl(activeScopeUserId), {
        method: 'POST',
        body: JSON.stringify({
            plan,
            version,
            event_id: eventId,
        }),
    })
        .catch(translateServerErrors(GET_SET_ERROR_SPEC))
        // return back plan and active scope user ID
        .then(() => ({ activeScopeUserId, plan }));

export const getEventsWithDowngradeConflicts = ({
    organizationId,
    desiredPackage,
    pageNumber = '1',
}) =>
    sdkRequest(
        _getEventsWithConflictsUrl({
            desiredPackage,
            organizationId,
            pageNumber,
        }),
    )
        .catch(translateServerErrors(GET_SET_ERROR_SPEC))
        .then(({ pagination, downgrade_conflicts }) =>
            deepKeysToCamel({
                desiredPackage,
                downgrade_conflicts,
                organizationId,
                pagination,
            }),
        );

export const getEventsData = (ids = []) =>
    sdkRequest(_getEventsDataUrl(ids))
        .catch(translateServerErrors(GET_SET_ERROR_SPEC))
        .then((response) => deepKeysToCamel(response));
